/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiSimpleComponentFromJSON, ApiSimpleComponentToJSON, } from './ApiSimpleComponent';
export function ApiReadComponentResponseFromJSON(json) {
    return ApiReadComponentResponseFromJSONTyped(json, false);
}
export function ApiReadComponentResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'component': !exists(json, 'component') ? undefined : ApiSimpleComponentFromJSON(json['component']),
    };
}
export function ApiReadComponentResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'component': ApiSimpleComponentToJSON(value.component),
    };
}
